<template>
  <v-theme-provider dark>
    <base-section
      id="back-to-blog-overview"
      class="text-center"
      space="56"
    >
      <router-link
        :to="{
          name: 'Blog'
        }"
        class="d-block"
      >
      &lt;&lt; {{ $t('Click here to get back to the blog overview_') }}
      </router-link>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BackToBlogOverview",

  provide: {
    heading: { align: "center" }
  }
};
</script>
